export const meta = {
  slug: {
    de: "rechtssichere-praxiswebsite",
    en: "legally-compliant-medical-website",
  },
  title: "Rechtssichere Praxiswebsite: DSGVO und HWG im Überblick",
  excerpt:
    "Welche rechtlichen Anforderungen eine Praxiswebsite in der DACH-Region erfüllen sollte – ruhig sortiert nach Datenschutz, Heilmittelwerbegesetz und Pflichtangaben.",
  category: "praxen",
  publishedAt: "2026-06-16",
  metaTitle: "Rechtssichere Praxiswebsite: DSGVO & HWG | OnePractix",
  metaDescription:
    "Praxiswebsite rechtssicher gestalten: ruhiger Überblick zu DSGVO, Heilmittelwerbegesetz und Pflichtangaben – aus Sicht eines healthcare-nativen Partners.",
  related: [
    "praxiswebsite-was-patienten-wirklich-suchen",
    "praxiswebsite-struktur-statt-design",
    "digitalisierung-arztpraxis-leitfaden",
  ],
  en: {
    title: "A legally sound medical website: GDPR and HWG explained",
    metaTitle: "Legally sound medical website: GDPR & HWG | OnePractix",
    metaDescription:
      "How to make a medical practice website legally sound in the DACH region: a calm overview of GDPR, the German Medical Advertising Act and required notices.",
    excerpt:
      "Which legal requirements a medical practice website should meet in the DACH region — calmly sorted by data protection, advertising law and required notices.",
  },
};

export default meta;